/**
 * 禁止登陆弹框 
 */
import React from 'react';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
// import { connect } from 'react-redux';
import { Modal, Input, message, Radio, Form } from 'antd';
import styles from './NoLogin.module.scss';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};
const { TextArea } = Input;

class NoLogin extends React.Component {
    formRef = React.createRef();
    state = {
        confirmLoading: false,
        showRemark: false
    };

    // 点击确认
    _handleOk = () => {
        this.formRef.current.validateFields().then((fieldsValue) => {
            const { id } = this.props;
            const { disableType, disableReason, disableRemark } = fieldsValue;
            this.setState({ confirmLoading: true });
            http('/?cmd=com.xqxc.api.pig.mis.biz.account.EmplMisService.disableEmpl', { id, disableType, disableReason, disableRemark }, 'POST').then(() => {
                message.success('禁用成功！');
                this.setState({ confirmLoading: false });
                this.props.closeModal(true);
            }).catch((e) => {
                this.setState({ confirmLoading: false });
                message.error(e.message);
            });
        });
    }

    // 点击取消
    _handleCancel = () => {
        this.props.closeModal();
    }

    render() {
        const { confirmLoading, showRemark } = this.state;
        return (
            <Modal
                width={700}
                centered
                title='禁用登陆'
                visible={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <Form
                        style={{ margin: '0 20px' }}
                        {...formItemLayout}
                        ref={this.formRef}
                        initialValues={{
                            disableType: 'DISABLE_LOGIN',
                            disableReason: 'DIMISSION'
                        }}
                        scrollToFirstError
                    >
                        <Form.Item
                            style={{ textAlign: 'left' }}
                            label="禁止类型"
                            name="disableType"
                            rules={[{ required: true }]}
                        >
                            <Radio.Group style={{ marginLeft: 6 }}>
                                {/* <Radio id='STOP' value='STOP'>停用</Radio> */}
                                <Radio id='DISABLE_LOGIN' value='DISABLE_LOGIN'>禁止登录</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            style={{ textAlign: 'left' }}
                            label="封禁理由"
                            name="disableReason"
                            rules={[{ required: true }]}
                        >
                            <Radio.Group style={{ marginLeft: 6 }} onChange={(e) => {
                                if (e.target.id == 'OTHER') {
                                    this.setState({ showRemark: true });
                                }
                            }}>
                                <Radio id='DIMISSION' value='DIMISSION'>离职</Radio>
                                <Radio id='LEAVE_WITHOUT_PAY' value='LEAVE_WITHOUT_PAY'>停薪离职</Radio>
                                <Radio id='OTHER' value='OTHER'>其他</Radio>
                            </Radio.Group>
                        </Form.Item>
                        {
                            showRemark ? <Form.Item
                                label="禁止原因"
                                name="disableRemark"
                                rules={[
                                    { max: 200, message: '最多可输入200个字' },
                                ]}
                            >
                                <TextArea placeholder='请输入禁止原因' rows={5} maxLength={200} showCount={true} />
                            </Form.Item> : null
                        }
                    </Form>
                </div>
            </Modal>
        );
    }
}

NoLogin.propTypes = {
    id: PropTypes.number, // 弹框入参
    closeModal: PropTypes.func.isRequired, // 关闭弹框的回调函数
};
// const ForgotProducDetails = Form.create({name: 'create-form' })(NoLogin);// 校验
// export default connect(null, null)(ForgotProducDetails);
export default NoLogin;
